// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { $delete, update, create, get, list } from "./operations.js";
export type {
  QueueDeleteOptionalParams,
  QueueUpdateOptionalParams,
  QueueCreateOptionalParams,
  QueueGetOptionalParams,
  QueueListOptionalParams,
} from "./options.js";
